import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../lib/api";
import ExportCsvButton from "../components/ExportCsvButton";

export default function AuditLogs() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/admin/audit-logs")
       .then((r) => setItems(r.data.items || []))
       .catch((e) => setErr(e.response?.data?.detail || "Forbidden"));
  }, []);

  return (
    <div className="p-8 space-y-6" data-testid="audit-page">
      <header className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#c15337]">{t("admin_pages.audit_section")}</div>
          <h1 className="font-heading text-3xl font-bold mt-1 text-[#114232]">{t("admin_pages.audit_title")}</h1>
        </div>
        <ExportCsvButton path="/admin/exports/audit-logs.csv" filename="audit_logs" testid="export-audit-csv" />
      </header>

      {err && (
        <div className="text-sm text-destructive bg-red-50 border border-red-200 rounded-sm p-3">{String(err)}</div>
      )}

      <div className="bg-white border border-border rounded-md overflow-x-auto">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead className="text-xs uppercase tracking-wider text-stone-500">
            <tr>
              <th className="text-left font-medium py-3 px-5">Timestamp</th>
              <th className="text-left font-medium py-3 px-5">Actor</th>
              <th className="text-left font-medium py-3 px-5">Action</th>
              <th className="text-left font-medium py-3 px-5">Entity</th>
              <th className="text-left font-medium py-3 px-5">IP</th>
            </tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-t border-border table-row-hover">
                <td className="py-3 px-5 text-xs text-muted-foreground font-mono">
                  {new Date(a.timestamp).toLocaleString()}
                </td>
                <td className="py-3 px-5 text-xs">
                  <div>{a.user_email || "system"}</div>
                  <div className="text-muted-foreground capitalize">{a.user_role?.replace(/_/g, " ")}</div>
                </td>
                <td className="py-3 px-5 font-medium">{a.action}</td>
                <td className="py-3 px-5 text-xs font-mono">
                  {a.entity_type}:{a.entity_id ? a.entity_id.slice(0, 8) : "—"}
                </td>
                <td className="py-3 px-5 text-xs font-mono">{a.ip_address || "—"}</td>
              </tr>
            ))}
            {items.length === 0 && !err && (
              <tr><td colSpan={5} className="py-10 text-center text-muted-foreground">No audit logs yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
